import { defineTokens } from '@chakra-ui/react/styled-system';

export const sizes = defineTokens.sizes({
	'0.5': { value: '0.125rem' },  // 2px
	'1': { value: '0.25rem' },     // 4px
	'1.5': { value: '0.375rem' },  // 6px
	'2': { value: '0.5rem' },      // 8px
	'2.5': { value: '0.625rem' },  // 10px
	'3': { value: '0.75rem' },     // 12px
	'3.5': { value: '0.875rem' },  // 14px
	'4': { value: '1rem' },        // 16px
	'4.5': { value: '1.125rem' },  // 18px
	'5': { value: '1.25rem' },     // 20px
	'5.5': { value: '1.375rem' },  // 22px
	'6': { value: '1.5rem' },      // 24px
	'7': { value: '1.75rem' },     // 28px
	'7.5': { value: '1.875rem' },  // 30px
	'8': { value: '2rem' },        // 32px
	'9': { value: '2.25rem' },     // 36px
	'9.5': { value: '2.375rem' }, // 38px
	'10': { value: '2.5rem' },     // 40px
	'10.5': { value: '2.625rem' },   // 42px
	'11': { value: '2.75rem' },    // 44px
	'11.25': { value: '2.8125rem' }, // 45px
	'12': { value: '3rem' },       // 48px
	'12.5': { value: '3.125rem' }, // 50px
	'13': { value: '3.25rem' },    // 52px
	'13.5': { value: '3.375rem' }, // 54px
	'14': { value: '3.5rem' },     // 56px
	'14.5': { value: '3.625rem' }, // 58px
	'15': { value: '3.75rem' },    // 60px
	'16': { value: '4rem' },       // 64px
	'16.25': { value: '4.0625rem' }, // 65px
	'17': { value: '4.25rem' },    // 68px
	'17.5': { value: '4.375rem' }, // 70px
	'18': { value: '4.5rem' },     // 72px
	'19': { value: '4.75rem' },    // 76px
	'20': { value: '5rem' },       // 80px
	'21': { value: '5.25rem' },    // 84px
	'21.5': { value: '5.375rem' }, // 86px
	'22': { value: '5.5rem' },     // 88px
	'22.5': { value: '5.625rem' }, // 90px
	'23': { value: '5.75rem' },    // 92px
	'24': { value: '6rem' },       // 96px
	'24.5': { value: '6.125rem' },  // 98px
	'25': { value: '6.25rem' },    // 100px
	'25.5': { value: '6.375rem' }, // 102px
	'26': { value: '6.5rem' },     // 104px
	'26.5': { value: '6.625rem' }, // 106px
	'27': { value: '6.75rem' },    // 108px
	'27.5': { value: '6.875rem' }, // 110px
	'28': { value: '7rem' },       // 112px
	'28.5': { value: '7.125rem' },  // 114px
	'29': { value: '7.25rem' },    // 116px
	'29.5': { value: '7.375rem' },  // 118px
	'30': { value: '7.5rem' },     // 120px
	'31': { value: '7.75rem' },    // 124px
	'32': { value: '8rem' },       // 128px
	'32.5': { value: '8.125rem' },  // 130px
	'34': { value: '8.5rem' },     // 136px
	'34.5': { value: '8.625rem' },  // 138px
	'35': { value: '8.75rem' },    // 140px
	'35.5': { value: '8.875rem' }, // 142px
	'36': { value: '9rem' },       // 144px
	'36.5': { value: '9.125rem' },  // 146px
	'37.5': { value: '9.375rem' },  // 150px
	'38': { value: '9.5rem' },     // 152px
	'38.5': { value: '9.625rem' },  // 154px
	'39': { value: '9.75rem' },    // 156px
	'40': { value: '10rem' },      // 160px
	'40.5': { value: '10.125rem' },  // 162px
	'41': { value: '10.25rem' },   // 164px
	'42': { value: '10.5rem' },    // 168px
	'42.5': { value: '10.625rem' },  // 170px
	'43.5': { value: '10.875rem' },  // 174px
	'44': { value: '11rem' },      // 176px
	'45': { value: '11.25rem' },    // 180px
	'46': { value: '11.5rem' },    // 184px
	'47.5': { value: '11.875rem' },  // 190px
	'48': { value: '12rem' },      // 192px
	'49': { value: '12.25rem' },   // 196px
	'50': { value: '12.5rem' },    // 200px
	'51': { value: '12.75rem' },   // 204px
	'51.5': { value: '12.875rem' },  // 206px
	'52': { value: '13rem' },      // 208px
	'53.5': { value: '13.375rem' },  // 214px
	'55.2': { value: '13.8rem' },    // 220px
	'56': { value: '14rem' },      // 224px
	'57.5': { value: '14.375rem' },  // 230px
	'58': { value: '14.5rem' },    // 232px
	'60': { value: '15rem' },      // 240px
	'61': { value: '15.25rem' },   // 244px
	'62.5': { value: '15.625rem' },  // 250px
	'63': { value: '15.75rem' },   // 252px
	'64': { value: '16rem' },      // 256px
	'65': { value: '16.25rem' },   // 260px
	'66.5': { value: '16.625rem' },  // 266px
	'67.5': { value: '16.875rem' },  // 270px
	'68': { value: '17rem' },      // 272px
	'70': { value: '17.5rem' },    // 280px
	'72': { value: '18rem' },      // 288px
	'75.5': { value: '18.875rem' },  // 302px
	'76.5': { value: '19.125rem' },  // 306px
	'78': { value: '19.5rem' },    // 312px
	'79': { value: '19.75rem' },   // 316px
	'80': { value: '20rem' },      // 320px
	'82': { value: '20.5rem' },    // 328px
	'82.5': { value: '20.625rem' },  // 330px
	'87.5': { value: '21.875rem' },  // 350px
	'87.75': { value: '21.9375rem' }, // 352px
	'90': { value: '22.5rem' },    // 360px
	'92.5': { value: '23.125rem' },  // 370px
	'94': { value: '23.5rem' },    // 376px
	'95': { value: '23.75rem' },   // 380px
	'96': { value: '24rem' },       // 384px
	'98': { value: '24.5rem' },     // 392px
	'99': { value: '24.75rem' },    // 396px
	'100': { value: '25rem' },      // 400px
	'102.5': { value: '25.625rem' },  // 410px
	'103': { value: '25.75rem' },   // 412px
	'107': { value: '26.75rem' },   // 428px
	'107.5': { value: '26.875rem' },  // 430px
	'123': { value: '30.75rem' },   // 492px
	'190': { value: '47.5rem' },    // 760px
	'200': { value: '50rem' },     // 800px
	'250': { value: '62.5rem' }   // 1000px
});